import { useQuery } from "@tanstack/react-query";
import { fetchAreaMembership } from "src/Pages/Company/OrganizationStructure/api";

interface IAreaMembership {
  employeeId: string;
  areaId: string;
  areaName: string;
}

const useFetchAreaMembership = (companyId: string, employeeId: string | null) =>
  useQuery<IAreaMembership, Error>({
    enabled: !!companyId && !!employeeId,
    queryKey: ["area-membership", companyId, employeeId],
    queryFn: async ({ signal }) =>
      fetchAreaMembership(companyId, employeeId, {
        signal,
      }),
  });

export default useFetchAreaMembership;
